/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';

/**
 *
 * @export
 * @interface PaginatedPerturbationList
 */
export interface PaginatedPerturbationList {
  /**
   *
   * @type {number}
   * @memberof PaginatedPerturbationList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedPerturbationList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedPerturbationList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Perturbation>}
   * @memberof PaginatedPerturbationList
   */
  results: Array<Perturbation>;
}

/**
 * Check if a given object implements the PaginatedPerturbationList interface.
 */
export function instanceOfPaginatedPerturbationList(value: object): value is PaginatedPerturbationList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedPerturbationListFromJSON(json: any): PaginatedPerturbationList {
  return PaginatedPerturbationListFromJSONTyped(json, false);
}

export function PaginatedPerturbationListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedPerturbationList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(PerturbationFromJSON),
  };
}

export function PaginatedPerturbationListToJSON(value?: PaginatedPerturbationList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(PerturbationToJSON),
  };
}
